import { route } from "typesafe-react-router";

export const licenceRoutes = {
    options: route("options"),
    renewal: route("licence", "renewal"),
    index: route("licence"),
};
